import React from "react";

import { FormRadioButtons, PanelFilters } from "@performyard/py-components";

import { type RolesFilterForm, RolesFilterFormSchema, type RolesFilters, STATUS_OPTIONS } from "./schema";

export interface RolesFilterPanelProps {
	isOpen: boolean;
	onClose: () => void;
	filters: RolesFilters;
	onApplyFilters: (filters: RolesFilters) => void;
}

export const RolesFilterPanel = ({ isOpen, onClose, filters, onApplyFilters }: RolesFilterPanelProps) => {
	const defaultValues: RolesFilterForm = {
		status: filters.status,
	};

	const handleSubmit = ({ value }: { value: RolesFilterForm }) => {
		onApplyFilters({ status: value.status });
		onClose();
	};

	return (
		<PanelFilters
			isOpen={isOpen}
			onClose={onClose}
			schema={RolesFilterFormSchema}
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
		>
			<div className="space-y-4">
				<FormRadioButtons<RolesFilters["status"]> id="status" label="Status" options={STATUS_OPTIONS} />
			</div>
		</PanelFilters>
	);
};

export default RolesFilterPanel;
